import { getSafeReturnUrl } from './returnUrl';

export type OrderType = 'booking' | 'change';

interface OrderFlowContext {
  orderType: OrderType;
  tUrl: string;
}

const storageKey = (token: string, bookingId: string) =>
  `emot:order-flow:${encodeURIComponent(token)}:${encodeURIComponent(bookingId)}`;

export const saveOrderFlowContext = (
  token: string,
  bookingId: string,
  context: OrderFlowContext
) => {
  if (!token || !bookingId) return;

  try {
    window.sessionStorage.setItem(
      storageKey(token, bookingId),
      JSON.stringify({
        orderType: context.orderType,
        tUrl: getSafeReturnUrl(context.tUrl) ?? ''
      })
    );
  } catch {
    // The in-memory flow still works if session storage is unavailable.
  }
};

export const readOrderFlowContext = (
  token?: string,
  bookingId?: string
): OrderFlowContext | null => {
  if (!token || !bookingId) return null;

  try {
    const raw = window.sessionStorage.getItem(storageKey(token, bookingId));
    if (!raw) return null;
    const value = JSON.parse(raw) as Partial<OrderFlowContext>;
    if (value.orderType !== 'booking' && value.orderType !== 'change') {
      return null;
    }
    return {
      orderType: value.orderType,
      tUrl: value.tUrl ? (getSafeReturnUrl(value.tUrl) ?? '') : ''
    };
  } catch {
    return null;
  }
};
